export default "__VITE_ASSET__MFzXkRyc__"